<template>
  <div style="height: calc(100vh - 196px);">
    <el-button
      type="primary"
      style="margin-bottom: 12px;margin-top:15px;"
      v-if="isBinding"
      @click="funcConfirm"
    >
      确认选择
    </el-button>
    <vxe-toolbar
      id="toolbarId_bi6"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
      v-if="!isBinding"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
        <el-button
          v-if="!parentData.isDetail && isCompanyShipmentOrAdmin"
          @click="funcAdd"
        >
          新增
        </el-button>
        <el-button @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" />
      <vxe-table-column>
        <vxe-table-column
          field="userName"
          title="姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.userName" placeholder="姓名" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="电话号码"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="电话号码"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="staffRole"
          title="角色"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.staffRole"
            placeholder="角色"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="注册时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-if="!parentData.isDetail && !isBinding"
        title="操作"
        width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="isCompanyShipmentOrAdmin"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="isCompanyShipmentOrAdmin"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="600"
      height="400"
      resize
    >
      <compAdd
        ref="addRef"
        :staff-type-options="staffTypeOptions"
        :company-code="listQuery.companyCode"
        :branch-code="parentData.branchCode"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="600"
      height="400"
      resize
    >
      <compEdit
        ref="editRef"
        :staff-type-options="staffTypeOptions"
        :company-code="listQuery.companyCode"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/shipmentStaffAdd.vue";
import compEdit from "./components/shipmentStaffEdit.vue";
import { getShipperList, delShipperInfo } from "@/api/shipment";
export default {
  name: "ShipmentStaffList",
  components: {
    compAdd,
    compEdit
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false
        };
      }
    },
    isBinding: {
      type: Boolean,
      default: false
    },
    selectShipment: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/shipment/exportShipment", //导出接口
        name: "员工管理"
      },
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      isCompanyShipmentOrAdmin: false,
      staffTypeOptions: [
        { label: "发货", value: 2, role: "DELIVERY" },
        { label: "财务", value: 3, role: "FINANCE" },
        { label: "收货", value: 4, role: "HARVEST" },
        { label: "客户", value: 5, role: "CUSTOMER" },
        { label: "代付", value: 6, role: "PAID" },
        { label: "自定义", value: 10, role: "" }
      ],
      listQuery: {
        gmtCreatedRange: "",
        companyCode: "",
        userName: "",
        phone: "",
        getStaff: 1,
        gmtCreatedStart: "",
        gmtCreatedEnd: "",
        staffTypes: "",
        staffType: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        exportType: 0
      }
    };
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isCompanyShipmentOrAdmin = partyType == "SHIPMENT_COMPANY" || isAdmin;
    // this.findList();
  },
  methods: {
    funcConfirm() {
      const selectRecords = this.$refs.xTable.getCheckboxRecords();
      this.$emit("confirm", selectRecords);
    },
    findList() {
      this.loading = true;
      this.listQuery.companyCode = this.$route.query.code
        ? this.$route.query.code
        : "";
      return new Promise(resolve => {
        getShipperList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          this.$nextTick(() => {
            this.setDefaultSelection();
          });
          resolve();
        });
      });
    },
    setDefaultSelection() {
      if (
        this.selectShipment &&
        this.selectShipment.subPartyList &&
        this.selectShipment.subPartyList.length > 0
      ) {
        const subPartyCodes = this.selectShipment.subPartyList.map(
          item => item.subPartyCode
        );
        const selectRows = this.tableData.filter(row =>
          subPartyCodes.includes(row.partyCode)
        );
        if (selectRows.length > 0) {
          this.$refs.xTable.setCheckboxRow(selectRows, true);
        }
      }
    },
    formatterStaffType({ cellValue }) {
      const item = this.staffTypeOptions.find(
        item1 => item1.value === cellValue
      );
      return item ? item.label : "";
    },
    // 添加方法
    funcAdd() {
      this.$refs.addRef.$refs.form.resetFields();
      this.modelAddFlag = true;
    },
    // 修改方法
    funcEdit(code) {
      this.$refs.editRef.$refs.form.resetFields();
      this.$refs.editRef.getInfo(code);
      this.modelEditFlag = true;
    },
    // 删除方法
    funcDelete(codes) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          delShipperInfo({ codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
      }
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    }
  }
};
</script>
<style></style>
